<script setup>
import AppRoute from 'src/router/app-route';
import ExternalRoute from 'src/router/external-route';
import { computed } from 'vue';

const $props = defineProps({
    link: {
        type: Object
    },
    hideIcons: {
        type: Boolean,
        default: false
    }
});

const isExternal = computed(() => $props.link.route instanceof ExternalRoute);

const labelClass = computed(() => {
    return $props.hideIcons
        ? 'font-mono text-caption text-uppercase text-weight-medium'
        : 'text-weight-medium text-body1';
});

function isFunction(route) {
    return typeof route === 'function';
}

function itemAttrs(route) {
    if (route instanceof AppRoute) {
        return { to: route, tag: 'router-link' };
    }
    if (route instanceof ExternalRoute) {
        return {
            href: route.url,
            rel: 'noopener noreferrer',
            tag: 'a',
            target: '_blank'
        };
    }
    return {};
}

function itemEvents(route) {
    if (isFunction(route)) {
        return { click: route };
    }
    return {};
}
</script>

<template>
    <q-item
        v-ripple
        :exact="$props.link.exactRoute"
        :title="$props.link.title"
        clickable
        v-bind="itemAttrs($props.link.route)"
        v-on="itemEvents($props.link.route)"
    >
        <q-item-section v-if="!$props.hideIcons && $props.link.icon" avatar>
            <q-icon :name="$props.link.icon"/>
        </q-item-section>
        <q-item-section>
            <q-item-label :class="labelClass">
                {{ $props.link.title }}
                <q-icon
                    v-if="$props.hideIcons && isExternal"
                    aria-hidden="true"
                    class="q-ml-xs"
                    data-test="external-mark"
                    name="sym_r_north_east"
                    size="14px"
                />
            </q-item-label>
        </q-item-section>
        <q-badge v-if="$props.link.count" color="negative">{{ $props.link.count }}</q-badge>
    </q-item>
</template>
